import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useFormStyles from '../../common/FormStyle';
import clsx from 'clsx';

// Help component
function Help() {

    const formStyles = useFormStyles();

    return (
        <Box display="flex" flexDirection="column" padding={2}>

            <Typography className={clsx(formStyles.accordionSubheader, formStyles.bold)} >
                Help
            </Typography>
        </Box>
    )
}

export default Help;